import React, { FC, useState } from 'react'
import { IonFooter, IonContent, IonPage, useIonViewWillEnter, useIonViewWillLeave } from '@ionic/react'
import { RouteComponentProps } from 'react-router-dom'
import { cartMobx, orderMobx, restaurantConfig, restaurantCenter } from 'restaurant'
import { CheckoutPayController, RestoreOrderController } from '@ctrls/index'
import { useHistoryNew } from '@utils'
import { store } from '@dt/fe-utils'
import '@pages/payfail/index.scss'

interface IProps extends RouteComponentProps {}

const PosPayfail: FC<IProps> = ({ match }) => {
  const history = useHistoryNew()
  const { id } = match.params as any
  const [reason, setReason] = useState('')

  const handleRepay = () => {
    history.replace('/posCheckout')
  }

  useIonViewWillEnter(() => {
    const state: any = history.location.state
    setReason(state && state.reason ? state.reason : i18n.t('pay.failedMessage'))
    cartMobx.setPosOrderPay(true)
    if (id) {
      restaurantCenter.init()
    }
    let _id = RestoreOrderController.getTempHold() || id
    if (orderMobx.order.ordersId || _id) {
      CheckoutPayController.resume(orderMobx.order.ordersId || _id).finally(() => {
        if (orderMobx.order.ordersId) {
          cartMobx.setOrdersId(orderMobx.order.ordersId)
        }
        if (_id) {
          const brandId = restaurantConfig.brandId || Config.BRANDID || orderMobx.order.brandId
          const storeId = restaurantConfig.storeId || Config.STOREID || orderMobx.order.storeId
          store.set(`${RestoreOrderController.localKey('prefix')}.${brandId}.${storeId}`, _id)
          RestoreOrderController.restore(true)
        }
      })
    }
  })

  useIonViewWillLeave(() => {
    cartMobx.setPosOrderPay(false)
  })

  return (
    <IonPage className='pay-fail-page'>
      <IonContent>
        <i className='iconfont icon-warning-circle' />
        <h4>{i18n.t('pageName.payfail')}</h4>
        <h6>{reason}</h6>
      </IonContent>
      <IonFooter>
        <div className='handle-btn'>
          <div className='repay' onClick={handleRepay}>{i18n.t('payfail.repay')}</div>
        </div>
      </IonFooter>
    </IonPage>
  )
}
export default PosPayfail
